import * as React from 'react';
import PropTypes from 'prop-types';
var SvgSportsWheelchairNormalXsmall = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.3 6.26c-.91 0-1.7.46-2.17 1.17L8.18 6.2c-.25-.1-.54.02-.65.27-.1.26.02.55.27.66l1.26.52H7.08C6.91 5.86 5.43 4.46 3.6 4.46 1.67 4.46.09 6.03.09 7.97c0 1.93 1.57 3.51 3.51 3.51 1.7 0 3.12-1.22 3.44-2.82h3.67c-.01.07-.02.14-.02.22 0 1.44 1.17 2.61 2.61 2.61s2.61-1.17 2.61-2.61-1.17-2.62-2.61-2.62zm-9.7 4.21c-1.38 0-2.51-1.12-2.51-2.51 0-1.38 1.12-2.51 2.51-2.51 1.38 0 2.51 1.12 2.51 2.51s-1.12 2.51-2.51 2.51zm9.7 0c-.89 0-1.61-.72-1.61-1.61 0-.04.01-.08.01-.12l1.41.58c.06.03.13.04.19.04a.499.499 0 00.19-.96l-1.41-.58c.29-.34.73-.56 1.21-.56.89 0 1.61.72 1.61 1.61s-.71 1.6-1.6 1.6z"
  }));
});
SvgSportsWheelchairNormalXsmall.defaultProps = {
  height: 16,
  width: 16
};
SvgSportsWheelchairNormalXsmall.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number
};
export default SvgSportsWheelchairNormalXsmall;